module.exports = {
  en: {
    calls: {
      title: 'Calls',
      subtitle: 'Events related with ondemand calls',
    },
    forms: {
      title: 'Forms',
      subtitle: 'Events related with forms like customers, agent forms and surveys',
    },
    recordings: {
      title: 'Recordings',
      subtitle: 'Events related with recordings and statuses',
    },
    config: {
      title: 'Account settings',
      subtitle: 'Events related with account configuration like users, segments and working hours',
    },
    appointments: {
      title: 'Meetings',
      subtitle: 'Events related with meetings',
    },
    'queue-created': {
      name: 'Queue created',
      description: 'A new queue was created',
    },
    'queue-abandoned': {
      name: 'Queue abandoned',
      description: 'Customer abandoned the queue manually',
    },
    'call-created': {
      name: 'Call ended',
      description: 'An answered call was ended',
    },
    'user-connected': {
      name: 'User connected',
      description: 'An agent was connected',
    },
    'user-disconnected': {
      name: 'User disconnected',
      description: 'An agent was disconnected',
    },
    'user-created': {
      name: 'New user',
      description: 'Was created a new user on your account',
    },
    'user-removed': {
      name: 'Removed user',
      description: 'An agent was deleted from your account',
    },
    'user-edited': {
      name: 'Edited user',
      description: 'An agent was edited on your account',
    },
    'form-edited': {
      name: 'Edited form',
      description: 'A form was edited on your account',
    },
    'form-removed': {
      name: 'Removed form',
      description: 'A form was removed on your account',
    },
    'form-created': {
      name: 'New form',
      description: 'A form was new on your account',
    },
    'form-received': {
      name: 'Edited form',
      description: 'A form was received from your customer',
    },
    'segment-created': {
      name: 'New segment',
      description: 'A new segment was created on your account',
    },
    'segment-removed': {
      name: 'Removed segment',
      description: 'A segment was removed on your account',
    },
    'segment-edited': {
      name: 'Edited segment',
      description: 'Segment was edited on your account',
    },
    'comment-created': {
      name: 'New comment',
      description: 'A new comment was created',
    },
    'agent-form-received': {
      name: 'Agent form',
      description: 'Form sent by agent',
    },
    'survey-received': {
      name: 'Survey received',
      description: 'Survey sent by customer after the call',
    },
    'recording-created': {
      name: 'Recording received',
      description: 'Recording received after being processed',
    },
    'recording-approved': {
      name: 'Recording approved',
      description: 'Recording has been approved by reviewer or admin',
    },
    'recording-rejected': {
      name: 'Recording rejected',
      description: 'Recording has been rejected by reviewer or admin',
    },
    'recording-deleted': {
      name: 'Recording deleted',
      description: 'Recording has been deleted by reviewer or admin',
    },
    'appointment-created': {
      name: 'Meeting created',
      description: 'New meeting was scheduled.'
    },
    'appointment-canceled': {
      name: 'Meeting canceled',
      description: 'A meeting was canceled.'
    },
    'appointment-reminder': {
      name: 'Meeting reminder',
      description: 'Reminders before the meeting',
    },
    'qms-notify': {
      name: 'QMS ticket notification',
      description: 'QMS assigned ticket notification'
    },
    'ai-calls': {
      name: 'AI analysis',
      description: 'Sets of AI analysis over calls'
    },
    'ai-appointments': {
      name: 'AI over appointments',
      description: 'Sets of AI analysis over appointments',
    },
    'working-hours-reminder': {
      name: 'Working hours reminder',
      description: 'Reminders before the working hours',
    },
    'links-created': {
      name: 'Personal link generated',
      description: 'A personal link was generated',
    },
    'call-answered': {
      name: 'Call answered',
      description: 'Call answered by the agent',
    },
    'call-invite': {
      name: 'Call invitation',
      description: 'Call invitation generated',
    },
    'service-invite': {
      name: 'Meeting invitation',
      description: 'Meeting invitation generated',
    },
    'service-started': {
      name: 'Meeting started',
      description: 'The meeting started with the agent',
    }
  },
  es: {
    calls: {
      title: 'Llamadas',
      subtitle: 'Eventos relacionados con llamadas bajo demanda',
    },
    forms: {
      title: 'Formularios',
      subtitle: 'Eventos relacionados con formularios como clientes, formularios de agentes y encuestas',
    },
    recordings: {
      title: 'Grabaciones',
      subtitle: 'Eventos relacionados con grabaciones y estados',
    },
    config: {
      title: 'Ajustes de cuenta',
      subtitle: 'Eventos relacionados con la configuración de la cuenta como usuarios, segmentos y horarios de trabajo',
    },
    appointments: {
      title: 'Reuniones',
      subtitle: 'Eventos relacionados con reuniones',
    },
    'queue-created': {
      name: 'Nueva fila',
      description: 'Una nueva fila ha sido creada',
    },
    'queue-abandoned': {
      name: 'Fila abandonada',
      description: 'El cliente ha abandonado la fila',
    },
    'call-created': {
      name: 'Llamada finalizada',
      description: 'Se ha finalizada una llamada contestada',
    },
    'user-connected': {
      name: 'Usuario conectado',
      description: 'Un agente se ha conectado a su cuenta',
    },
    'user-disconnected': {
      name: 'Usuario desconectado',
      description: 'Un agente se ha desconectado de su cuenta',
    },
    'user-created': {
      name: 'Nuevo usuario',
      description: 'Se ha creado un nuevo agente en su cuenta',
    },
    'user-removed': {
      name: 'Usuario eliminado',
      description: 'Se ha eliminado un agente de su cuenta',
    },
    'user-edited': {
      name: 'Usuario editado',
      description: 'Se ha editado información de un agente de su cuenta',
    },
    'form-edited': {
      name: 'Formulario editado',
      description: 'Se ha editado información de un formulario de su cuenta',
    },
    'form-removed': {
      name: 'Formulario eliminado',
      description: 'Se ha eliminado un formulario de su cuenta',
    },
    'form-created': {
      name: 'Nuevo formulario',
      description: 'Se ha creado un formulario en su cuenta',
    },
    'form-received': {
      name: 'Formulario recibido',
      description: 'Se ha recibido un nuevo formulario de un cliente',
    },
    'segment-created': {
      name: 'Nuevo segmento',
      description: 'Se ha creado un nuevo segmento en su cuenta',
    },
    'segment-removed': {
      name: 'Segmento eliminado',
      description: 'Se ha eliminado un segmento de su cuenta',
    },
    'segment-edited': {
      name: 'Segmento editado',
      description: 'Se ha editado información de un segmento de su cuenta',
    },
    'comment-created': {
      name: 'Nuevo comentario',
      description: 'Se ha creado un nuevo comentario en una llamada',
    },
    'agent-form-received': {
      name: 'Formulario agente',
      description: 'Formulario rellenado por el agente',
    },
    'survey-received': {
      name: 'Encuesta recibida',
      description: 'Encuesta enviada por el cliente a finalizar una llamada',
    },
    'recording-created': {
      name: 'Nueva grabación',
      description: 'Nueva grabación recibida',
    },
    'recording-approved': {
      name: 'Grabación aprobada',
      description: 'Grabación aprobada por un revisor o administrador.',
    },
    'recording-rejected': {
      name: 'Grabación rechazada',
      description: 'Grabación rechazada por un revisor o administrador.',
    },
    'recording-deleted': {
      name: 'Grabación eliminada',
      description: 'Grabación eliminada por un administrador.',
    },
    'appointment-created': {
      name: 'Nueva reunión',
      description: 'Nueva reunión agendada.'
    },
    'appointment-canceled': {
      name: 'Reunión cancelada',
      description: 'Una reunión ha sido cancelada.'
    },
    'appointment-reminder': {
      name: 'Recordatorio de reunión',
      description: 'Envío de recordatorio antes de la reunión',
    },
    'qms-notify': {
      name: 'Notificación ticket QMS',
      description: 'Notificación de ticket asignado a QMS'
    },
    'ai-calls': {
      name: 'IA en llamadas',
      description: 'Conjunto de análisis por IA en llamadas'
    },
    'ai-appointments': {
      name: 'IA en reuniones',
      description: 'Conjunto de análisis por IA en reuniones',
    },
    'working-hours-reminder': {
      name: 'Recordatorio de horario laboral',
      description: 'Envío de recordatorio antes del horario laboral',
    },
    'links-created': {
      name: 'Enlace personal generado',
      description: 'Se ha generado un enlace personal',
    },
    'call-answered': {
      name: 'Llamada contestada',
      description: 'Llamada contestada por el agente',
    },
    'call-invite': {
      name: 'Invitación a llamada',
      description: 'Invitación a llamada generada',
    },
    'service-invite': {
      name: 'Invitación a reunión',
      description: 'Invitación a reunión generada',
    },
    'service-started': {
      name: 'Reunión iniciada',
      description: 'La reunión se inició con el agente',
    }
  },
  fr: {
    calls: {
      title: 'Appels',
      subtitle: 'Événements liés aux appels à la demande',
    },
    forms: {
      title: 'Formulaires',
      subtitle: 'Événements liés aux formulaires comme les clients, les formulaires d\'agents et les enquêtes',
    },
    recordings: {
      title: 'Enregistrements',
      subtitle: 'Événements liés aux enregistrements et aux statuts',
    },
    config: {
      title: 'Configuration du compte',
      subtitle: 'Événements liés à la configuration du compte comme les utilisateurs, les segments et les heures de travail',
    },
    appointments: {
      title: 'Réunions',
      subtitle: 'Événements liés aux réunions',
    },
    'queue-created': {
      name: 'Nouvelle file',
      description: 'Une nouvelle file a été créée',
    },
    'queue-abandoned': {
      name: 'File abandonnée',
      description: 'Le client a abandonné la file',
    },
    'call-created': {
      name: 'Appel terminé',
      description: 'Un appel répondu a été terminé',
    },
    'user-connected': {
      name: 'Utilisateur connecté',
      description: 'Un agent s\'est connecté à son compte',
    },
    'user-disconnected': {
      name: 'Utilisateur déconnecté',
      description: 'Un agent s\'est déconnecté de son compte',
    },
    'user-created': {
      name: 'Nouvel utilisateur',
      description: 'Un nouvel agent a été créé dans votre compte',
    },
    'user-removed': {
      name: 'Utilisateur supprimé',
      description: 'Un agent a été supprimé de votre compte',
    },
    'user-edited': {
      name: 'Utilisateur modifié',
      description: 'Les informations d\'un agent de votre compte ont été modifiées',
    },
    'form-edited': {
      name: 'Formulaire modifié',
      description: 'Les informations d\'un formulaire de votre compte ont été modifiées',
    },
    'form-removed': {
      name: 'Formulaire supprimé',
      description: 'Un formulaire a été supprimé de votre compte',
    },
    'form-created': {
      name: 'Nouveau formulaire',
      description: 'Un formulaire a été créé dans votre compte',
    },
    'form-received': {
      name: 'Formulaire reçu',
      description: 'Un nouveau formulaire d\'un client a été reçu',
    },
    'segment-created': {
      name: 'Nouveau segment',
      description: 'Un nouveau segment a été créé dans votre compte',
    },
    'segment-removed': {
      name: 'Segment supprimé',
      description: 'Un segment a été supprimé de votre compte',
    },
    'segment-edited': {
      name: 'Segment modifié',
      description: 'Les informations d\'un segment de votre compte ont été modifiées',
    },
    'comment-created': {
      name: 'Nouveau commentaire',
      description: 'Un nouveau commentaire a été créé sur un appel',
    },
    'agent-form-received': {
      name: 'Formulaire agent',
      description: 'Formulaire rempli par l\'agent',
    },
    'survey-received': {
      name: 'Enquête reçue',
      description: 'Enquête envoyée par le client à la fin d\'un appel',
    },
    'recording-created': {
      name: 'Nouvelle enregistrement',
      description: 'Nouvelle enregistrement reçue',
    },
    'recording-approved': {
      name: 'Enregistrement approuvé',
      description: 'Enregistrement approuvé par un réviseur ou administrateur.',
    },
    'recording-rejected': {
      name: 'Enregistrement rejeté',
      description: 'Enregistrement rejeté par un réviseur ou administrateur.',
    },
    'recording-deleted': {
      name: 'Enregistrement supprimé',
      description: 'Enregistrement supprimé par un administrateur.',
    },
    'appointment-created': {
      name: 'Nouvelle réunion',
      description: 'Nouvelle réunion planifiée.'
    },
    'appointment-canceled': {
      name: 'Réunion annulée',
      description: 'Une réunion a été annulée.'
    },
    'appointment-reminder': {
      name: 'Rappel de réunion',
      description: 'Envoi de rappel avant la réunion',
    },
    'qms-notify': {
      name: 'Notification ticket QMS',
      description: 'Notification de ticket attribué à QMS'
    },
    'ai-calls': {
      name: 'IA dans les appels',
      description: 'Ensemble d\'analyses par IA dans les appels'
    },
    'ai-appointments': {
      name: 'IA dans les réunions',
      description: 'Ensemble d\'analyses par IA dans les réunions',
    },
    'working-hours-reminder': {
      name: 'Rappel des heures de travail',
      description: 'Envoi de rappel avant les heures de travail',
    },
    'links-created': {
      name: 'Lien personnel généré',
      description: 'Un lien personnel a été généré',
    },
    'call-answered': {
      name: 'Appel répondu',
      description: 'Appel répondu par l’agent',
    },
    'call-invite': {
      name: 'Invitation à un appel',
      description: 'Invitation à un appel générée',
    },
    'service-invite': {
      name: 'Invitation à une réunion',
      description: 'Invitation à une réunion générée',
    },
    'service-started': {
      name: 'Réunion démarrée',
      description: 'La réunion a démarré avec l’agent',
    }
  }

};
